import { useRouter } from 'expo-router'
import { Platform } from 'react-native'

import { env } from '@/src/config/env'
import { getIsMobile } from '@/src/general/utils/getIsMobile'
import { GTM } from '@/src/general/utils/gtm'
import { useRoutes } from '@/src/general/utils/routes'

import { getConnectDetails, removeConnectDetails, type TConnectDetails } from '../utils/connectDetails'

export const useConnectRedirect = (connectDetails?: Partial<TConnectDetails>) => {
  const router = useRouter()
  const { routes } = useRoutes()

  return async () => {
    const { fromIframe, redirectUrl, reload, reloadUrl, socialName, gtmData, shouldDismiss } = {
      ...getConnectDetails(),
      ...connectDetails,
    }

    // Remove connect details cookie to avoid interferences later.
    removeConnectDetails()

    /** Has already reloaded (connection on mobile device) */
    const hasReloaded = socialName && getIsMobile()
    /** Should reload now */
    const shouldReload = (reload || (!redirectUrl && reloadUrl)) && Platform.OS === 'web'
    /** Has already reloaded or will reload now */
    const isReload = shouldReload || hasReloaded

    const url = (isReload && reloadUrl) || redirectUrl || routes['prayer-space']()

    if (gtmData) {
      gtmData?.forEach((gtmDataItem) => GTM.sendEvent(gtmDataItem))
      // Add a delay before reloading to ensure request to GTM is not cancelled
      if (shouldReload || fromIframe) await new Promise((resolve) => setTimeout(resolve, 300))
    }

    if (fromIframe && Platform.OS === 'web') {
      window.parent.postMessage(
        JSON.stringify({ type: 'connect-redirect', url }),
        env.EXPO_PUBLIC_APP_BASE_URL || 'https://hozana.org',
      )
      return
    }

    if (shouldReload) {
      window.location.href = url
      return
    }

    if (shouldDismiss) {
      return router.dismiss()
    }

    if (!redirectUrl) {
      return
    }

    return router.navigate(url)
  }
}
